// Central image registry for ARVI. Replace any URL here with a real
// ARVI photograph and the change will reflect everywhere on the site.
//
// Tip: drop your own photos into /app/frontend/public/ and reference
// them as e.g. "/photos/hero.jpg" — they'll load instantly.

export const IMAGES = {
  // Hero — the bride wearing an ARVI piece
  hero: "/collection/closeup-3.jpeg",

  // Brand Story — close-up of the artist's hands at work
  story: "/collection/closeup-1.jpeg",

  // Collections — three categories
  collectionSaree: "/collection/saree.jpeg",
  collectionSuit: "/collection/suits.jpeg",
  collectionBridal: "/collection/lehenga.jpeg",

  // Gallery / Showcase — five editorial tiles
  galleryFabric: "https://images.pexels.com/photos/4863038/pexels-photo-4863038.jpeg",
  galleryGold: "https://images.unsplash.com/photo-1763400234383-8b9ecbb9c043",
  galleryBrush: "https://images.unsplash.com/photo-1763400126795-d83e07d3449e",
  galleryDrape: "https://images.pexels.com/photos/29153195/pexels-photo-29153195.jpeg",
  galleryPortrait: "https://images.unsplash.com/photo-1727430228383-aa1fb59db8bf",

  // Reviews — saree photographs + customer avatars
  reviewSaree1: "https://images.pexels.com/photos/31232391/pexels-photo-31232391.jpeg",
  reviewAvatar1: "https://images.unsplash.com/photo-1727430228383-aa1fb59db8bf",
  reviewSaree2: "https://images.unsplash.com/photo-1763400234383-8b9ecbb9c043",
  reviewAvatar2: "https://images.pexels.com/photos/4863038/pexels-photo-4863038.jpeg",
};

// Craftsmanship video clips. Drop MP4 files into /app/frontend/public/videos/
// and set `src` for each clip below. Until files are present, the section
// shows a graceful "Studio footage coming soon" placeholder.
//
// Recommended encode (short, light, web-friendly):
//   ffmpeg -i in.mov -t 8 -vf "scale='min(640,iw)':-2" -c:v libx264 -crf 28 \
//     -preset veryfast -movflags +faststart -an out.mp4
export const CRAFT_VIDEOS = {
  saree: {
    finalImage: "/craftsmanship/saree-blue-organza/saree-output.jpeg",
    clips: [
      { src: "/craftsmanship/saree-blue-organza/clips/clip-01.mp4", caption: "First wash of colour" },
      { src: "/craftsmanship/saree-blue-organza/clips/clip-02.mp4", caption: "Outlining the motif" },
      { src: "/craftsmanship/saree-blue-organza/clips/clip-03.mp4", caption: "Layering the petals" },
      { src: "/craftsmanship/saree-blue-organza/clips/clip-04.mp4", caption: "Detail brushwork" },
    ],
  },
  suit: {
    finalImage: "/craftsmanship/chunni/chunni-ouput.jpeg",
    clips: [
      { src: "/craftsmanship/chunni/clips/clip-01.mp4", caption: "Mixing the palette" },
      { src: "/craftsmanship/chunni/clips/clip-02.mp4", caption: "Setting the border" },
      { src: "/craftsmanship/chunni/clips/clip-03.mp4", caption: "Final ornament" },
      { src: "/craftsmanship/chunni/clips/clip-04.mp4", caption: "The signing stroke" },
    ],
  },
};
